import React, {Component} from 'react';
import {Banner} from '../../Components'
import './Purchase.scss'
import WOW from 'wowjs'
import {Helmet} from "react-helmet"

import {StripeProvider} from 'react-stripe-elements';
import {Elements} from 'react-stripe-elements';
import {injectStripe} from 'react-stripe-elements';
import {CardElement} from 'react-stripe-elements';
import {withRouter, Link} from 'react-router-dom'
import {observer, inject} from 'mobx-react'
import {observable} from 'mobx'

import DATA_STRIPE from './DATA_STRIPE'
let apiKey
process.env.NODE_ENV === 'development'
    ? apiKey = DATA_STRIPE.apikey.test
    : apiKey = DATA_STRIPE.apikey.live

class PurchasePage extends Component {

    componentDidMount() {
        new WOW
            .WOW({mobile: false})
            .init();
        window.scrollTo(0, 0)
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Purchase | GPbook</title>
                </Helmet>
                <Banner
                    title="Purchase"
                    subtitle="You can purchase the print copy or subscribe online."
                    // subtitle="There is a current delay on deliveries due to a shortage of materials with our printer."
                    
                    />
                <StripeProvider apiKey={apiKey}>
                    <MyStoreCheckout/>
                </StripeProvider>
            </div>
        )
    }

}

class MyStoreCheckout extends Component {
    render() {
        return (
            <Elements>
                <CheckoutForm/>
            </Elements>
        );
    }
}

@inject("store")
@observer
class _CheckoutForm extends Component {

    @observable error = false
    @observable errorMessage = "Your card details may be incorrect, please check and try again"
    @observable loading = 0

    handleSubmit = (ev) => {
        // We don't want to let default form submission happen here, which would refresh
        // the page.
        ev.preventDefault();

        // 1. Verifying Card Details
        this.loading = 1

        const {purchase} = this.props.store

        // Verify all details entered
        if (!(purchase.contactName && purchase.name && purchase.phone && purchase.address_line1)) {

            this.loading = 0
            purchase.checkAllInputsFilled = true
            document
                .getElementById('contact-details')
                .scrollIntoView({block: 'start', behavior: 'smooth'})
            return

        }

        // Collect purchase cost to be passed to invoicing email system
        const cost = {
            book: this.props.store.bookPrice,
            online: this.props.store.onlinePrice,
			combine: this.props.store.combinePrice,
			psych: this.props.store.psychPrice,
            total: this.props.store.totalPrice,
            combineBookPrice: this.props.store.combineBookPrice,
            combineOnlinePrice: this.props.store.combineOnlinePrice
        }

        // Only 1 Psychology Edition
        if ((purchase.bookQuantity + purchase.onlineQuantity + purchase.combineQuantity) === 0 && (purchase.psychQuantity === 1)) {
            this
                .props
                .store
                .api
                .post('/purchase', {
                    purchase: {
                        ...purchase,
                        cost
                    },
                })
                .then(({data}) => {
                    // Purchase complete, timeout to next page
                    if (data.success) {

                        this.props.store.purchase.customer_id = data.customer_id
                        this.loading = 3

                        setTimeout(() => {
                            this
                                .props
                                .history
                                .push('/purchase/complete')
                        }, 2500)

                    } else {
                        this.loading = 0
                        this.error = true
                        this.errorMessage = data.message
                    }

                })
                .catch(err => {
                    console.log(err);
                    this.error = true;
                    this.loading = 0
                })
        } else {

        // Get Customer Token ID
        this
            .props
            .stripe
            .createToken({
                ...purchase
            })
            .then(({token}) => {

                // Purchasing System
                this.loading = 2
                this.error = false

                if (token) {
                    this
                        .props
                        .store
                        .api
                        .post('/purchase', {
                            purchase: {
                                ...purchase,
                                cost
                            },
                            token
                        })
                        .then(({data}) => {
                            // Purchase complete, timeout to next page
                            if (data.success) {

                                this.props.store.purchase.customer_id = data.customer_id
                                this.loading = 3

                                setTimeout(() => {
                                    this
                                        .props
                                        .history
                                        .push('/purchase/complete')
                                }, 2500)

                            } else {
                                this.loading = 0
                                this.error = true
                                this.errorMessage = data.message
                            }

                        })
                        .catch(err => {
                            console.log(err);
                            this.error = true;
                            this.loading = 0
                        })
                } else {
                    document
                        .getElementById('payment-summary')
                        .scrollIntoView({block: 'start', behavior: 'smooth'})
                    this.error = true
                    this.loading = 0
                }
            })
            .catch(err => {
                console.log(err);
                this.error = true;
                this.loading = 0
            })
        }

    }

    render() {
        const {
            bookPrice,
            onlinePrice,
            addOnline,
            addCombine,
            purchase,
            addBook,
            combinePrice,
            totalPrice,
            // totalSubPrice,
            combineBookPrice,
            combineOnlinePrice,
            combinePriceDiscount
        } = this.props.store
        const discount = this.props.store.purchase.organisation === "General Practice"
            ? true
            : false

        return (
            <div className="container page purchase">

                <form onSubmit={this.handleSubmit}>

                    <div className="details">
                        <h3>Checkout</h3>
                    </div>

                    <Row hr>
                        <h2>1. Organisation</h2>
                        <p>What type of person/organisation are you?
                            <div>
                                <small>Please make sure this item is selected correctly as it can affect pricing.</small>
                            </div>
                        </p>
                        <div className="btn-group org" role="group">
                            <button
                                type="button"
                                onClick={() => purchase.organisation = "General Practice"}
                                className={`btn ${purchase.organisation === "General Practice" || "white"}`}>
                                <i className="fa fa-user-md"></i>General Practice</button>
                            <button
                                type="button"
                                onClick={() => purchase.organisation = "Specialist"}
                                className={`btn ${purchase.organisation === "Specialist" || "white"}`}>
                                <i className="fa fa-male"></i>
                                Specialist</button>
                            <button
                                type="button"
                                onClick={() => purchase.organisation = "Other"}
                                className={`btn ${purchase.organisation === "Other" || "white"}`}>
                                <i className="fa fa-building"></i>Other</button>
                        </div>
                        {purchase.organisation === "Other"
                            ? <div className="row">
                                    <div className="col-md-4">
                                        <input
                                            type="text"
                                            className="input"
                                            placeholder="Please specify your organisation"
                                            value={purchase.organisationOther}
                                            onChange={e => purchase.organisationOther = e.target.value}/>
                                    </div>
                                </div>
                            : null}
                    </Row>

                    <div
                        className={`${purchase.organisation
                        ? "show"
                        : "hidden"}`}>

                        <div className="details">
                            <h2>2. Select Products</h2>
                            <p>Please select which items and quantities you wish to purchase. Volume discount pricing is automatically calculated.
                            </p>
                        </div>

                        {/* <div className="free-trial-box">
                            <img src={require('./one-month-free.png')} alt="GPbook One Month Free" className="wow pulse" data-wow-duration="1s" // data-wow-iteration="infinite"
                            />
                            <h3>Trial the Online Directory for Free</h3>
                            <p>You can trial our online directory risk free and without obligation for a
                                month. Simply add orders for how many users you will need below and complete the
                                form including billing information. If you decide to cancel before the end of
                                the first month, you won’t be charged.</p>
                        </div> */}

                        <table className="table">
                            <thead>
                                <tr>
                                    <td width="95">Quantity</td>
                                    <td width="112"></td>
                                    <td>Product</td>
                                    <td>Unit Cost</td>
                                    <td width="250">Total Cost (inc)</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><input
                                        type="number"
                                        placeholder="#"
                                        value={purchase.bookQuantity}
                                        onChange={addBook}
                                        style={{
                width: 75
            }}/>
                                        <div
                                            className="btn white addremove"
                                            onClick={() => addBook({
                                            target: {
                                                value: purchase.bookQuantity + 1
                                            }
                                        })}>
                                            <i className="fa fa-plus"></i>
                                        </div>
                                        <div
                                            className="btn white addremove"
                                            onClick={() => addBook({
                                            target: {
                                                value: purchase.bookQuantity - 1
                                            }
                                        })}>
                                            <i className="fa fa-minus"></i>
                                        </div>
                                    </td>
                                    <td>
                                        <img src={require('./purchase-mssd.png')} alt="purchase-mssd" width="92"/></td>
                                    <td>
                                        <h3 className="base">Paper Edition
                                            {/* <small> ({`${new Date().getFullYear()}`})</small> */}
                                            <small> 2024</small>
                                        </h3>
                                        <p>The Medical & Surgical Specialist Referral Directory.</p>
                                        {/* <p>Delivery takes 1-2 weeks</p> */}
                                        <p>Item will be delivered early 2024.</p>
                                    </td>
                                    <td>${this.props.store.bookUnitPrice}</td>
                                    <td>
                                        {purchase.bookQuantity
                                            ? <div className="btn price">
                                                    <small>$</small>{bookPrice.toFixed(2)}</div>
                                            : null}
                                    </td>
								</tr>
								
								{/* <tr>
                                    <td><input
                                        type="number"
                                        placeholder="Psychology Edition (2020)"
                                        value={purchase.psychQuantity}
                                        style={{
                width: 75
            }}
                                        onChange={this.props.store.addPsych}/>
                                        <div
                                            className="btn white addremove"
                                            onClick={() => this.props.store.addPsych({
                                            target: {
                                                value: purchase.psychQuantity + 1
                                            }
                                        })}>
                                            <i className="fa fa-plus"></i>
                                        </div>
                                        <div
                                            className="btn white addremove"
                                            onClick={() => this.props.store.addPsych({
                                            target: {
                                                value: purchase.psychQuantity - 1
                                            }
                                        })}>
                                            <i className="fa fa-minus"></i>
                                        </div>
                                    </td>
                                    <td>
                                        <img src={require('./purchase-psych.png')} alt="psych-gpbook" width="92"/></td>
                                    <td>
                                        <h3 className="base">Psychology Edition <small> (2020)</small>	</h3>
                                        <p>Mental Health and Psychology Referral Directory.</p>
                                    </td>
                                    <td>
                                      
                                        ${25}
                                    </td>
                                    <td>
                                        {purchase.psychQuantity
                                            ? <span>
                                                    <div className="btn price">
                                                        <small>$</small>  {this.props.store.psychPrice.toFixed(2)}
                                                    </div>
                                                </span>
                                            : null}
                                    </td>
								</tr> */}
								
                                <tr>
                                    <td><input
                                        type="number"
                                        placeholder="#"
                                        value={purchase.onlineQuantity}
                                        onChange={addOnline}
                                        style={{
                width: 75
            }}/>
                                        <div
                                            className="btn white addremove"
                                            onClick={() => addOnline({
                                            target: {
                                                value: purchase.onlineQuantity + 1
                                            }
                                        })}>
                                            <i className="fa fa-plus"></i>
                                        </div>
                                        <div
                                            className="btn white addremove"
                                            onClick={() => addOnline({
                                            target: {
                                                value: purchase.onlineQuantity - 1
                                            }
                                        })}>
                                            <i className="fa fa-minus"></i>
                                        </div>
                                    </td>
                                    <td>
                                        <img src={require('./purchase-gpbook.png')} alt="purchase-mssd" width="92"/></td>
                                    <td>
                                        <h3>Online Directory
                                            <small> (per room or user)</small>
                                        </h3>
                                        <p>(e.g. if you have 3 clinic rooms then purchase 3 licences)</p>
                                    </td>
                                    <td>${discount
                                            ? "48"
                                            : "72"}</td>
                                    <td>
                                        {purchase.onlineQuantity
											? <div className="btn price">
												${onlinePrice.toFixed(2)}
											</div>
                                            : null}
                                        {purchase.onlineQuantity
                                            ? <div
                                                    style={{
                                                    marginTop: 4
                                                }}>
                                                    <div>First Month is Free</div>
                                                </div>
                                            : null}
                                    </td>
                                </tr>

                               

                            </tbody>
                        </table>

                        <div
                            className={`${ ((purchase.psychQuantity + purchase.onlineQuantity + purchase.bookQuantity) > 0)
                            ? "show"
                            : "hidden"}`}>

                            <div className="details" id="contact-details">
                                <h2>3. Contact Details</h2>
                                <p>Please fill in your contact details. These will be used to email your receipt
                                    and for account creation.
                                </p>
                            </div>

                            <Row hr>
                                <div className="row m-t-1">
                                    <div className="col-md-4">
                                        <h4 className="text-black">Business Name*</h4>
                                        <input
                                            type="text"
                                            name="name"
                                            className={`input ${ !purchase.name && purchase.checkAllInputsFilled && "missing"}`}
                                            placeholder="Medical Group"
                                            value={purchase.name}
                                            onChange={e => purchase.name = e.target.value}/>
                                    </div>
                                </div>
                                <div className="row m-t-1">
                                    <div className="col-md-4">
                                        <h5 className="text-black">Contact Name*
                                            <small>
                                                <i>(e.g. Practice Manager)</i>
                                            </small>
                                        </h5>
                                        <input
                                            type="text"
                                            name="contactName"
                                            className={`input ${ !purchase.contactName && purchase.checkAllInputsFilled && "missing"}`}
                                            placeholder="John Smith"
                                            value={purchase.contactName}
                                            onChange={e => purchase.contactName = e.target.value}/>
                                    </div>
                                </div>

                                <hr/>

                                <div className="row">
                                    <div className="col-md-3">
                                        <h5 className="text-black">Email Address*</h5>
                                        <input
                                            name="email"
                                            type="email"
                                            className={`input ${ !purchase.email && purchase.checkAllInputsFilled && "missing"}`}
                                            placeholder="reception@medicalgroup.com.au"
                                            value={purchase.email}
                                            onChange={e => purchase.email = e.target.value}/>
                                        <small className="m-t-1">Your account details will be emailed to this address</small>
                                    </div>
                                </div>
                                <div className="row m-t-1">
                                    <div className="col-md-3">
                                        <h5 className="text-black">Phone Number*</h5>
                                        <input
                                            name="phone"
                                            type="tel"
                                            className={`input ${ !purchase.phone && purchase.checkAllInputsFilled && "missing"}`}
                                            placeholder="(08) 9400 2000"
                                            value={purchase.phone}
                                            onChange={e => purchase.phone = e.target.value}/>
                                    </div>
                                    <div className="col-md-3">
                                        <h5>Fax Number</h5>
                                        <input
                                            name="fax"
                                            type="tel"
                                            className={`input`}
                                            placeholder="(08) 9400 3000"
                                            value={purchase.fax}
                                            onChange={e => purchase.fax = e.target.value}/>
                                    </div>

                                    <div className="col-md-3">
                                        <h5>Website</h5>
                                        <input
                                            name="website"
                                            type="text"
                                            className={`input`}
                                            placeholder="https://www.medicalgroup.com.au"
                                            value={purchase.website}
                                            onChange={e => purchase.website = e.target.value}/>
                                    </div>

                                </div>

                                <hr/>

                                <div className="row m-t-1">
                                    <div className="col-md-3">
                                        <h5 className="text-black">Address Line 1*</h5>
                                        <input
                                            name="address_line1"
                                            type="text"
                                            className={`input ${ !purchase.address_line1 && purchase.checkAllInputsFilled && "missing"}`}
                                            placeholder="1/20 Streetname, St"
                                            value={purchase.address_line1}
                                            onChange={e => purchase.address_line1 = e.target.value}/>
                                    </div>
                                    <div className="col-md-3">
                                        <h5>Address Line 2</h5>
                                        <input
                                            name="address_line2"
                                            type="text"
                                            className={`input`}
                                            placeholder="20 Streetname, St"
                                            value={purchase.address_line2}
                                            onChange={e => purchase.address_line2 = e.target.value}/>
                                    </div>
                                </div>
                                <div className="row m-t-1">
                                    <div className="col-md-3">
                                        <h5 className="text-black">Suburb*</h5>
                                        <input
                                            name="address_city"
                                            type="text"
                                            className={`input ${ !purchase.address_city && purchase.checkAllInputsFilled && "missing"}`}
                                            placeholder="Suburb"
                                            value={purchase.address_city}
                                            onChange={e => purchase.address_city = e.target.value}/>
                                    </div>

                                    <div className="col-md-3">
                                        <h5>State</h5>
                                        <input
                                            name="address_state"
                                            type="text"
                                            className={`input ${ !purchase.address_state && purchase.checkAllInputsFilled && "missing"}`}
                                            placeholder="State"
                                            value={purchase.address_state}
                                            onChange={e => purchase.address_state = e.target.value}/>
                                    </div>

                                </div>
                                <div className="row m-t-1">

                                    <div className="col-md-2">
                                        <h5 className="text-black">Postcode*</h5>
                                        <input
                                            name="address_zip"
                                            type="number"
                                            className={`input ${ !purchase.address_zip && purchase.checkAllInputsFilled && "missing"}`}
                                            placeholder="6000"
                                            value={purchase.address_zip}
                                            onChange={e => purchase.address_zip = e.target.value}/>
                                    </div>
                                    <div className="col-md-4">
                                        <h5>Country</h5>
                                        <input
                                            name="address_country"
                                            type="text"
                                            className={`input ${ !purchase.address_country && purchase.checkAllInputsFilled && "missing"}`}
                                            placeholder="6000"
                                            value={purchase.address_country}
                                            onChange={e => purchase.address_country = e.target.value}/>
                                    </div>
                                </div>

                                <hr/>

                                <div className="row m-t-1">
                                    <div className="col-md-6">
                                        <h5>Full Delivery Address
                                            <small>
                                                <i> (Will be used for delivery of the {`${new Date().getFullYear()}`} publication)</i>
                                            </small>
                                        </h5>
                                        <input
                                            name="deliveryAddress"
                                            type="text"
                                            className="input"
                                            placeholder="20 Street, Suburb, State, Postcode"
                                            value={purchase.deliveryAddress}
                                            onChange={e => purchase.deliveryAddress = e.target.value}/>
                                    </div>
                                </div>
                            </Row>

                            <div className="details" id="payment-summary">
                                <h2>4. Payment Summary</h2>
                                <p>If you are unable to pay by credit card, please contact us by email to make
                                    other arrangements.</p>
                            </div>

                            <div className="row">
                                <div className="col-md-9">
                                    <table className="pricing table">
                                        <thead>
                                            <tr>
                                                <th>Product</th>
                                                <th width="100">Quantity</th>
                                                <th width="150">Price
                                                    <small>(inc GST)</small>
                                                </th>
                                                <th width="200">Recurring
                                                </th>
                                            </tr>

                                        </thead>
                                        <tbody>

                                            {((purchase.bookQuantity + purchase.onlineQuantity + purchase.psychQuantity) === 0)
                                                ? <tr>
                                                        <td>No Product Items added yet. Please select a quantity from the Products section.</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                : null}

                                            {purchase.bookQuantity
                                                ? <tr>
                                                        <td>
                                                            <b>Paper Edition</b><br/>
                                                            Medical & Surgical Specialist Referral Directory</td>
                                                        <td>{purchase.bookQuantity}</td>
                                                        <th>${bookPrice.toFixed(2)}</th>
                                                        <td></td>
                                                    </tr>
                                                : null}
                                            {/* {purchase.psychQuantity >= 1
                                                ? <tr>
                                                        <td>
                                                            <b>Psychology Edition (free)</b><br/>
                                                            Mental Health and Psychology Referral Directory</td>
                                                        <td>1</td>
                                                        <th>Free</th>
                                                        <td>(Shipping end of February)</td>
                                                    </tr>
                                                : null}
											{purchase.psychQuantity > 1
                                                ? <tr>
                                                        <td>
                                                            <b>Psychology Edition</b><br/>
                                                            Mental Health and Psychology Referral Directory</td>
                                                        <td>{purchase.psychQuantity - 1}</td>
                                                        <th>${this.props.store.psychPrice.toFixed(2)}</th>
                                                        <td></td>
                                                    </tr>
                                                : null} */}
                                            
                                                {purchase.psychQuantity
                                                ? <tr>
                                                        <td>
                                                            <b>Psychology Edition</b><br/>
                                                            Mental Health and Psychology Referral Directory</td>
                                                        <td>{purchase.psychQuantity }</td>
                                                        <th>${this.props.store.psychPrice.toFixed(2)}</th>
                                                        <td></td>
                                                    </tr>
                                                : null} 
                                            {purchase.onlineQuantity
                                                ? <tr>
                                                        <td>
                                                            <b>Online Directory</b><br/>
                                                            Online Subscription<br/>
                                                            First Month Free. Billing automatically recurs until cancelled
                                                        </td>
                                                        <td>
                                                            {purchase.onlineQuantity}
                                                        </td>
                                                        <td>$0 first month</td>
                                                        <td>${onlinePrice.toFixed(2)}/per year</td>
                                                    </tr>
                                                : null}
                                            {purchase.combineQuantity
                                                ? <tr>
                                                        <td>
                                                            <b>Combined Online + Paper</b><br/>
                                                            Medical & Surgical Specialist Referral Directory +<br/>
                                                            Online Subscription 12 Months<br/>
                                                            First Month Free. Billing automatically recurs annually until cancelled.
                                                        </td>
                                                        <td>
                                                            {purchase.combineQuantity}
                                                        </td>
                                                        <th>${combineBookPrice.toFixed(2)}
                                                            (for books)</th>
                                                        <th>${combineOnlinePrice.toFixed(2)}
                                                            per year for online subscription(s)</th>
                                                    </tr>
                                                : null}

                                            <tr>
                                                <td></td>
                                                <td>
                                                    <b>Tax (GST)</b>
                                                </td>
                                                <td>${((totalPrice) - (totalPrice / 1.1)).toFixed(2)}</td>
                                                <td></td>
                                            </tr>

                                            <tr>
                                                <td
                                                    style={{
                                                    textAlign: 'right'
                                                }}>Up Front</td>
                                                <td>
                                                    <b>Total</b>
                                                </td>
                                                <th>
                                                    <b>${totalPrice.toFixed(2)}</b>
                                                </th>
                                                <td></td>
                                            </tr>

                                            {(purchase.combineQuantity || purchase.onlineQuantity)
                                                ? <tr>
                                                        <td
                                                            colSpan="4"
                                                            style={{
                                                            textAlign: 'center'
                                                        }}>
                                                            After 1 month free trial, recurring payments will begin.
                                                        </td>

                                                    </tr>
                                                : null}

                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {((
                                purchase.bookQuantity + purchase.onlineQuantity + purchase.combineQuantity
                                + purchase.psychQuantity 
                            ) === 0
                               // && (purchase.psychQuantity === 1)
                            ) ? null : <Row title="Credit Card">
                                <div className="row">
                                    <div className="col-md-8">
                                        <p className="m-b-1">Please enter your credit card details.</p>
                                        <CardElement
                                            style={{
                                            base: {
                                                fontSize: '24px'
                                            }
                                        }}/>
                                        <h4 className="m-t-1">Total: ${totalPrice.toFixed(2)}</h4>
                                    </div>
                                </div>
                            </Row>}

                            

                            {!this.loading && <div>
                                {((purchase.bookQuantity + purchase.onlineQuantity + purchase.combineQuantity + purchase.psychQuantity) !== 0)
                                    ? <button type="submit" className="btn lg secondary m-t-1">
                                            <i className="fa fa-shopping-cart"></i>Purchase Order</button>
                                    : <h4>Please add a product to your card in order to start your purchase.</h4>}
                            </div>
}

                            {/* <Link to="/purchase/complete">Complete</Link> */}

                            {this.loading === 1 && <div className="btn lg base m-t-1">
                                <i className="fa fa-cog fa-spin"></i>Verifying Card Details</div>}

                            {this.loading === 2 && <div className="btn lg primary m-t-1">
                                <i className="fa fa-cog fa-spin"></i>Processing Order</div>}

                            {this.loading === 3 && <div>
                                <div className="btn lg secondary m-t-1">
                                    <i className="fa fa-check"></i>Order Complete!</div>
                                <div className="m-t-1">
                                    <i className="fa fa-cog fa-spin"></i>
                                    Loading Receipt...</div>
                            </div>}

                            {this.error
                                ? <div>
                                        <button className="btn base m-t-1">
                                            {this.errorMessage || "There appears to be a problem"}
                                        </button>
                                        {/* <h5 className="m-t-1">Please contact us on <a href="mailto:info@gpbook.com.au">info@gpbook.com.au</a> regarding the issue.</h5> */}
                                    </div>
                                : null}

                        </div>

                    </div>

                </form>

            </div>
        );
    }
}

const Row = ({title, img, className, hr, children}) => <div className="input-row">
    {img && <img src={img} alt="GPbook Online"/>}
    <div className="group">
        <h3 className={className}>{title}</h3>
        <div>
            {children}
        </div>
    </div>
    <hr className={hr && "large"}/>
</div>

const CheckoutForm = injectStripe(withRouter(_CheckoutForm));

export default PurchasePage;


// WEBPACK FOOTER //
// ./src/Containers/Purchase/Purchase.js